import { logDebugEvent } from '../core/factories/events/eventDebugging'
import { segmentAnalytics, SEGMENT_OPTIONS } from '../core/factories/events/segmentAnalytics'
import { type FetchCurrentEnterpriseAccountQuery } from '../../__codegen__/api'

const groupByPartner = (partnerId: string) => {
  const identifier = partnerId.toString()

  segmentAnalytics().group(identifier, { id: identifier }, SEGMENT_OPTIONS)
  logDebugEvent('group', `Grouping the user with partner: ${identifier}`, { id: identifier })
}

const groupUser = ({
  assignedPartnerIds,
}: FetchCurrentEnterpriseAccountQuery['currentEnterpriseAccount']) => {
  if (assignedPartnerIds.length === 1) {
    // If a user has exactly one partner, we mark them as part of the analytics group
    groupByPartner(assignedPartnerIds[0])
  } else {
    // Otherwise, we skip grouping them.
    logDebugEvent(
      'group',
      'Skipping grouping for user - did not have one partner',
      assignedPartnerIds
    )
  }
}

// eslint-disable-next-line import/no-default-export
export default groupUser
